// DAT Tagging System - Sections, Subjects, Topics, and Subtopics for DAT questions

export const DAT_SECTIONS = [
  { key: 'biology', name: 'Biology', short_name: 'Bio' },
  { key: 'chemistry', name: 'General Chemistry', short_name: 'Gen Chem' },
  { key: 'orgchem', name: 'Organic Chemistry', short_name: 'Org Chem' },
  { key: 'pat', name: 'Perceptual Ability', short_name: 'PAT' },
  { key: 'rct', name: 'Reading Comprehension', short_name: 'RCT' },
  { key: 'qrt', name: 'Quantitative Reasoning', short_name: 'QRT' },
];

export const DAT_SECTIONS_MAP = Object.fromEntries(DAT_SECTIONS.map(s => [s.key, s]));

// Biology subjects
export const DAT_BIOLOGY_SUBJECTS = [
  { key: 'cell_molecular', name: 'Cell and Molecular Biology' },
  { key: 'diversity_life', name: 'Diversity of Life' },
  { key: 'structure_function', name: 'Structure and Function of Systems' },
  { key: 'genetics', name: 'Genetics' },
  { key: 'evolution_ecology', name: 'Evolution and Ecology' },
];

export const DAT_BIOLOGY_TOPICS = {
  cell_molecular: [
    { key: 'cell_metabolism', name: 'Cell metabolism' },
    { key: 'photosynthesis', name: 'Photosynthesis' },
    { key: 'enzymology', name: 'Enzymology' },
    { key: 'membrane_transport', name: 'Membrane transport' },
    { key: 'thermodynamics', name: 'Thermodynamics' },
    { key: 'mitosis_meiosis', name: 'Mitosis and meiosis' },
    { key: 'organelles', name: 'Organelles' },
    { key: 'plasma_membrane', name: 'Plasma membrane' },
    { key: 'biomolecules', name: 'Biomolecules' },
    { key: 'biology_lab_techniques', name: 'Biology lab techniques' },
    { key: 'eukaryotic_cell_biology', name: 'Eukaryotic cell biology' },
    { key: 'prokaryotic_cell_biology', name: 'Prokaryotic cell biology' },
    { key: 'integrated_relationships', name: 'Integrated Relationships' },
  ],
  diversity_life: [
    { key: 'viruses', name: 'Viruses' },
    { key: 'archaebacteria', name: 'Archaebacteria' },
    { key: 'eubacteria', name: 'Eubacteria' },
    { key: 'fungi', name: 'Fungi' },
    { key: 'protista', name: 'Protista' },
    { key: 'plantae', name: 'Plantae' },
    { key: 'animalia', name: 'Animalia' },
    { key: 'integrated_relationships', name: 'Integrated Relationships' },
  ],
  structure_function: [
    { key: 'integumentary_system', name: 'Integumentary system' },
    { key: 'skeletal_system', name: 'Skeletal system' },
    { key: 'muscular_system', name: 'Muscular system' },
    { key: 'circulatory_system', name: 'Circulatory system' },
    { key: 'lymphatic_system', name: 'Lymphatic system' },
    { key: 'immune_system', name: 'Immune system' },
    { key: 'digestive_system', name: 'Digestive system' },
    { key: 'respiratory_system', name: 'Respiratory system' },
    { key: 'urinary_system', name: 'Urinary system' },
    { key: 'nervous_system', name: 'Nervous system' },
    { key: 'sensory_system', name: 'Sensory system' },
    { key: 'endocrine_system', name: 'Endocrine system' },
    { key: 'reproductive_systems', name: 'Reproductive systems' },
    { key: 'integrated_relationships', name: 'Integrated Relationships' },
    { key: 'developmental_biology', name: 'Developmental biology' },
  ],
  genetics: [
    { key: 'molecular_genetics', name: 'Molecular genetics' },
    { key: 'human_genetics', name: 'Human genetics' },
    { key: 'classical_genetics', name: 'Classical genetics' },
    { key: 'chromosomal_genetics', name: 'Chromosomal genetics' },
    { key: 'genetic_technology', name: 'Genetic technology' },
    { key: 'biology_lab_techniques', name: 'Biology lab techniques' },
    { key: 'developmental_mechanisms', name: 'Developmental mechanisms' },
    { key: 'genomics', name: 'Genomics' },
    { key: 'gene_expression', name: 'Gene expression' },
    { key: 'epigenetics', name: 'Epigenetics' },
    { key: 'integrated_relationships', name: 'Integrated Relationships' },
  ],
  evolution_ecology: [
    { key: 'natural_selection', name: 'Natural selection' },
    { key: 'population_genetics', name: 'Population genetics' },
    { key: 'speciation', name: 'Speciation' },
    { key: 'animal_behavior', name: 'Animal behavior' },
    { key: 'ecology', name: 'Ecology' },
    { key: 'symbiosis', name: 'Symbiosis' },
    { key: 'integrated_relationships', name: 'Integrated Relationships' },
  ],
};

// General Chemistry subjects
export const DAT_GCHEM_SUBJECTS = [
  { key: 'stoichiometry', name: 'Stoichiometry and General Concepts' },
  { key: 'gases', name: 'Gases' },
  { key: 'liquids_solids', name: 'Liquids and Solids' },
  { key: 'solutions', name: 'Solutions' },
  { key: 'acids_bases', name: 'Acids and Bases' },
  { key: 'chemical_equilibria', name: 'Chemical Equilibria' },
  { key: 'thermodynamics', name: 'Thermodynamics' },
  { key: 'chemical_kinetics', name: 'Chemical Kinetics' },
  { key: 'oxidation_reduction', name: 'Oxidation-Reduction Reactions' },
  { key: 'atomic_molecular_structure', name: 'Atomic and Molecular Structure' },
  { key: 'periodic_properties', name: 'Periodic Properties' },
  { key: 'nuclear_reactions', name: 'Nuclear Reactions' },
  { key: 'gchem_lab_techniques', name: 'Gchem Lab Techniques' },
];

// Organic Chemistry subjects
export const DAT_OCHEM_SUBJECTS = [
  { key: 'mechanisms', name: 'Mechanisms' },
  { key: 'chemical_synthesis', name: 'Chemical Synthesis' },
  { key: 'acid_base_chemistry', name: 'Ochem Acid-Base Chemistry' },
  { key: 'chemical_physical_properties', name: 'Chemical and Physical Properties of Molecules' },
  { key: 'structural_evaluation', name: 'Structural Evaluation' },
];

export const DAT_OCHEM_TOPICS = [
  { key: 'functional_groups', name: 'Functional Groups' },
  { key: 'nomenclature', name: 'Nomenclature' },
  { key: 'stereochemistry', name: 'Stereochemistry' },
  { key: 'cyclohexanes', name: 'Cyclohexanes' },
  { key: 'structure_bonding', name: 'Structure and Bonding' },
  { key: 'aromaticity', name: 'Aromaticity' },
  { key: 'reaction_coordinate_diagrams', name: 'Reaction Coordinate Diagrams' },
  { key: 'resonance', name: 'Resonance' },
  { key: 'separation_lab_techniques', name: 'Separation Lab Techniques' },
  { key: 'spectroscopy', name: 'Spectroscopy' },
  { key: 'ochem_lab_techniques', name: 'Ochem Lab Techniques' },
  { key: 'substitution_reactions', name: 'Substitution Reactions' },
  { key: 'elimination_reactions', name: 'Elimination Reactions' },
  { key: 'free_radical_halogenation', name: 'Free Radical Halogenation' },
  { key: 'electrophilic_addition', name: 'Electrophilic Addition' },
  { key: 'electrophilic_substitution', name: 'Electrophilic Substitution' },
  { key: 'nucleophilic_addition', name: 'Nucleophilic Addition' },
  { key: 'grignard_reaction', name: 'Grignard Reaction' },
  { key: 'wittig_reaction', name: 'Wittig Reaction' },
  { key: 'aldol_reaction', name: 'Aldol Reaction' },
  { key: 'nae_reaction', name: 'NAE Reaction' },
  { key: 'michael_addition', name: 'Michael Addition' },
  { key: 'tollens_reaction', name: "Tollen's Reaction" },
  { key: 'friedel_crafts_reaction', name: 'Friedel Crafts Reaction' },
  { key: 'conjugate_addition', name: 'Conjugate Addition' },
  { key: 'ozonolysis', name: 'Ozonolysis' },
  { key: 'diels_alder_reaction', name: 'Diels-Alder Reaction' },
  { key: 'redox_reactions', name: 'Redox Reactions' },
];

// Perceptual Ability subjects and topics
export const DAT_PAT_SUBJECTS = [
  { key: 'apertures', name: 'Apertures' },
  { key: 'view_recognition', name: 'View Recognition' },
  { key: 'angle_discrimination', name: 'Angle Discrimination' },
  { key: 'paper_folding', name: 'Paper Folding' },
  { key: 'cube_counting', name: 'Cube Counting' },
  { key: 'spatial_relations', name: 'Spatial Relations' },
];

export const DAT_PAT_TOPICS = {
  apertures: [
    { key: 'perimeter', name: 'Perimeter' },
    { key: 'dark_side', name: 'Dark Side' },
    { key: 'full_shape', name: 'Full Shape' },
    { key: 'rock_question', name: 'Rock Question' },
    { key: 'macro_micro_method', name: 'Macro-Micro Method' },
  ],
  view_recognition: [
    { key: 'ceb_technique', name: 'CEB Technique' },
    { key: 'perimeter', name: 'Perimeter' },
    { key: 'symmetry', name: 'Symmetry' },
    { key: 'solid_dashed_cebs', name: 'Solid/Dashed CEBs' },
    { key: 'visualize_shape', name: 'Visualize the Shape' },
  ],
  angle_discrimination: [
    { key: 'acute_angles', name: 'Acute angles' },
    { key: 'obtuse_angles', name: 'Obtuse angles' },
    { key: 'mixed_angles', name: 'Mixed angles' },
  ],
  paper_folding: [
    { key: 'basic_folds', name: 'Basic Folds' },
    { key: 'symmetry', name: 'Symmetry' },
    { key: 'diagonal_folds', name: 'Diagonal Folds' },
    { key: 'open_folds', name: 'Open Folds' },
    { key: '8_grid_folds', name: '8-Grid Folds' },
    { key: 'partial_holes', name: 'Partial Holes' },
    { key: 'multiple_holes', name: '>1 Hole' },
  ],
  cube_counting: [{ key: 'floating_cubes', name: 'Floating Cubes' }],
  spatial_relations: [
    { key: 'main_face', name: 'Main Face' },
    { key: 'geometric_shapes', name: 'Geometric Shapes' },
    { key: 'cubes', name: 'Cubes' },
  ],
};

export const DAT_ANGLE_DISCRIMINATION_SUBTOPICS = [
  { key: '2_by_2', name: '2-by-2' },
  { key: 'hockey_sticks', name: 'Hockey sticks' },
  { key: 'identical_angles', name: 'Identical angles' },
];

// Reading Comprehension
export const DAT_RC_SUBJECTS = [
  { key: 'basic_science', name: 'Basic Science Passage' },
  { key: 'health_science', name: 'Health Science Passage' },
  { key: 'applied_science', name: 'Applied Science Passage' },
];

export const DAT_RC_TOPICS = [
  { key: 'strategy', name: 'Strategy' },
  { key: 'retrieval', name: 'Retrieval' },
  { key: 'inference', name: 'Inference' },
  { key: 'open_ended', name: 'Open-ended' },
  { key: 'new_information', name: 'New Information' },
  { key: 'two_parts', name: 'Two Parts' },
  { key: 'meaning_in_context', name: 'Meaning in Context' },
  { key: 'attitude_tone', name: 'Attitude/Tone' },
  { key: 'purpose', name: 'Purpose' },
  { key: 'main_point', name: 'Main Point' },
  { key: 'insertion', name: 'Insertion' },
];

export const DAT_RC_PASSAGE_SUBTOPICS = [
  { key: 'biology_passage', name: 'Biology Passage' },
  { key: 'chemistry_passage', name: 'Chemistry Passage' },
  { key: 'physics_passage', name: 'Physics Passage' },
];

// Quantitative Reasoning
export const DAT_QR_SUBJECTS = [
  { key: 'arithmetic', name: 'Arithmetic' },
  { key: 'algebra', name: 'Algebra' },
  { key: 'geometry', name: 'Geometry' },
  { key: 'trigonometry', name: 'Trigonometry' },
  { key: 'probability_statistics', name: 'Probability and Statistics' },
  { key: 'quantitative_comparison', name: 'Quantitative Comparison' },
  { key: 'data_sufficiency', name: 'Data Sufficiency' },
  { key: 'applications', name: 'Applications' },
];

export const DAT_QR_TOPICS = [
  { key: 'basic_operations', name: 'Basic Operations' },
  { key: 'fractions_decimals_percents', name: 'Fractions, Decimals & Percents' },
  { key: 'exponents_roots', name: 'Exponents & Roots' },
  { key: 'logarithms', name: 'Logarithms' },
  { key: 'algebraic_expressions', name: 'Algebraic Expressions' },
  { key: 'linear_equations', name: 'Linear Equations' },
  { key: 'systems_of_equations', name: 'Systems of Equations' },
  { key: 'factoring', name: 'Factoring' },
  { key: 'quadratic_equations', name: 'Quadratic Equations' },
  { key: 'graphing', name: 'Graphing' },
  { key: 'absolute_value', name: 'Absolute Value' },
  { key: 'inequalities', name: 'Inequalities' },
  { key: 'functions', name: 'Functions' },
  { key: 'word_problems', name: 'Word Problems' },
  { key: 'unit_conversions', name: 'Unit Conversions' },
  { key: 'central_tendency', name: 'Measure of Central Tendency' },
  { key: 'measures_of_variation', name: 'Measures of Variation' },
  { key: 'probability', name: 'Probability' },
  { key: 'combinatorics', name: 'Combinatorics' },
  { key: '2d_geometry', name: '2D Geometry' },
  { key: '3d_geometry', name: '3D Geometry' },
  { key: 'trigonometric_identities', name: 'Trigonometric Identities' },
  { key: 'trigonometric_values', name: 'Trigonometric Values' },
];

// Common subtopic across multiple sections
export const DAT_COMMON_SUBTOPICS = [
  { key: 'except', name: 'Except' },
  { key: 'least', name: 'Least' },
  { key: 'not', name: 'Not' },
];

// Helper function to get subjects by section
export function getDATSubjectsBySection(sectionKey) {
  switch (sectionKey) {
    case 'biology':
      return DAT_BIOLOGY_SUBJECTS;
    case 'chemistry':
      return DAT_GCHEM_SUBJECTS;
    case 'orgchem':
      return DAT_OCHEM_SUBJECTS;
    case 'pat':
      return DAT_PAT_SUBJECTS;
    case 'rct':
      return DAT_RC_SUBJECTS;
    case 'qrt':
      return DAT_QR_SUBJECTS;
    default:
      return [];
  }
}

// Helper function to get topics by section (subject required for Biology and PAT)
export function getDATTopicsBySection(sectionKey, subjectKey = null) {
  switch (sectionKey) {
    case 'biology':
      return DAT_BIOLOGY_TOPICS[subjectKey] || [];
    case 'orgchem':
      return DAT_OCHEM_TOPICS;
    case 'pat':
      return DAT_PAT_TOPICS[subjectKey] || [];
    case 'rct':
      return DAT_RC_TOPICS;
    case 'qrt':
      return DAT_QR_TOPICS;
    default:
      return [];
  }
}

let _cachedTagMap = null;
export function getDATTagsMap() {
  if (_cachedTagMap) return _cachedTagMap;
  _cachedTagMap = Object.fromEntries(
    [
      ...DAT_SECTIONS,
      ...DAT_BIOLOGY_SUBJECTS,
      ...Object.values(DAT_BIOLOGY_TOPICS).flat(),
      ...DAT_GCHEM_SUBJECTS,
      ...DAT_OCHEM_SUBJECTS,
      ...DAT_OCHEM_TOPICS,
      ...DAT_PAT_SUBJECTS,
      ...Object.values(DAT_PAT_TOPICS).flat(),
      ...DAT_ANGLE_DISCRIMINATION_SUBTOPICS,
      ...DAT_RC_SUBJECTS,
      ...DAT_RC_TOPICS,
      ...DAT_RC_PASSAGE_SUBTOPICS,
      ...DAT_QR_SUBJECTS,
      ...DAT_QR_TOPICS,
      ...DAT_COMMON_SUBTOPICS,
    ].map(t => [t.key, t]),
  );
  return _cachedTagMap;
}

// Helper function to get subtopics (if applicable)
export function getDATSubtopics(sectionKey, subjectKey = null) {
  if (sectionKey === 'pat' && subjectKey === 'angle_discrimination') {
    return DAT_ANGLE_DISCRIMINATION_SUBTOPICS;
  }
  if (sectionKey === 'rct' && subjectKey === 'basic_science') {
    return [...DAT_COMMON_SUBTOPICS, ...DAT_RC_PASSAGE_SUBTOPICS];
  }
  if (['biology', 'chemistry', 'orgchem', 'qrt', 'rct'].includes(sectionKey)) {
    return DAT_COMMON_SUBTOPICS;
  }
  return [];
}
